import { render, staticRenderFns } from "./cpSearch.vue?vue&type=template&id=0966887b&scoped=true&"
import script from "./cpSearch.vue?vue&type=script&lang=js&"
export * from "./cpSearch.vue?vue&type=script&lang=js&"
import style0 from "./cpSearch.vue?vue&type=style&index=0&id=0966887b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966887b",
  null
  
)

export default component.exports